import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowDown } from '@fortawesome/free-solid-svg-icons'

import './accordion.scss'

const AccordionItemHeader = ({ question, isOpen }) => {
  const icon = isOpen ? faArrowDown : faArrowRight

  return (
    <label>
      <FontAwesomeIcon icon={icon} />
      {question}
    </label>
  )
}

const AccordionItem = ({ i, question, answer, expanded, setExpanded }) => {
  const isOpen = i === expanded

  return (
    <>
      <motion.header
        initial={true}
        onClick={() => setExpanded(isOpen ? false : i)}>
        <AccordionItemHeader question={question} isOpen={isOpen} />
      </motion.header>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.section
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: "auto" },
              collapsed: { opacity: 0, height: 0 }
            }}
            transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <div className="p-3" dangerouslySetInnerHTML={{
              __html: answer
            }}></div>
          </motion.section>
        )}
      </AnimatePresence>
    </>
  )
}

export const Accordion = ({ items }) => {
  const [expanded, setExpanded] = useState(0)

  return (
    <div className="accordion-container">
      {items.map((value, i) => (
        <AccordionItem 
          i={i}
          key={i}
          question={value.question} 
          answer={value.answer} 
          expanded={expanded} 
          setExpanded={setExpanded} />
      ))}
    </div>
  )
}
